import {CSSProperties} from "react";
import {DraggableProvided, DraggableStateSnapshot} from "@hello-pangea/dnd";

export function constrainVerticalAxis(provided: DraggableProvided, snapshot: DraggableStateSnapshot) {
  // @hello-pangea/dnd does not support constraining drags to an axis but you
  // can fake it by overwriting the dragged element's transform.
  //
  // See: https://github.com/atlassian/react-beautiful-dnd/issues/958

  if (snapshot.isDragging && provided.draggableProps.style != null) {
    let transform = provided.draggableProps.style.transform;

    if (transform != null) {
      transform = transform.replace(/\(.+,/, "(0,");
      provided.draggableProps.style.transform = transform;
    }
  }
}

/**
 * Style for a vertically-constrained draggable in an optimistically-ordered
 * list. Skips the drop animation: the optimistic overlay already renders the
 * final order, so animating the drop would hold the item in its lifted state
 * while the save is in flight.
 */
export function optimisticDragStyle(provided: DraggableProvided, snapshot: DraggableStateSnapshot): CSSProperties {
  constrainVerticalAxis(provided, snapshot);
  return {...provided.draggableProps.style, ...(snapshot.isDropAnimating ? {transitionDuration: "0.001s"} : {})};
}
